import React from "react";
import Category from "./Category";

function CategoryList(props: {
  categories?: [{ key: string; doc_count: number }];
}) {
  const { categories } = props;
  return (
    <div className="wrapper-sidebar-menu hidden-xs">
      <ul className="list-group">
        <li className="list-group-item">
          <h4>Filter By Category</h4>
        </li>
        {categories &&
          categories.map((cat) => (
            <Category key={cat.key} value={cat.key} count={cat.doc_count} />
          ))}
      </ul>
    </div>
  );
}

export default CategoryList;
